import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import {
  loadCategorizeMenuitems,
  loadUserSavedRestaurantVouchers,
  loadUserSavedRestaurantVoucherStatus,
} from '../../../../core/state/payment/paymentMiddleware';
import {
  selectCheckRestaurantVouchersBalanceUnknown,
  selectCheckRestaurantVouchersCoverOrderAmount,
  selectRestaurantVouchersForStore,
} from '../../../../core/state/payment/paymentSelectors';
import { getUtils } from '../../../../utils';
import { basketActions, basketSelectors } from '../../../../weborder/redux';
import * as Store from '../../../../weborder/Store';
import {
  OuterProps,
  RestaurantVoucherSection as RestaurantVoucherSectionPartial,
} from './RestaurantVoucherSection';

export type StateProps = ReturnType<typeof mapStateToProps>;
export type DispatchProps = ReturnType<typeof mapDispatchToProps>;

const mapStateToProps = (state: Store.State, ownProps: OuterProps) => {
  const { prId, orderTotalToPay } = ownProps;
  const { canApplyRestaurantVoucher = true } = state.payments;

  const menuItems = state.basket?.items || {};

  const currentLang = getUtils.activeLanguageCode(state.locale.languages);
  const restaurantVouchers = selectRestaurantVouchersForStore(state, prId);
  const canRestaurantVouchersCoverOrderAmount =
    selectCheckRestaurantVouchersCoverOrderAmount(state, orderTotalToPay, prId);
  const isRestaurantVouchersBalanceUnknown =
    selectCheckRestaurantVouchersBalanceUnknown(state, prId);
  const selectedPaymentOption =
    basketSelectors.getSelectedPaymentOrDefault(state);

  return {
    canApplyRestaurantVoucher,
    canRestaurantVouchersCoverOrderAmount,
    currentLang,
    isRestaurantVouchersBalanceUnknown,
    menuItems,
    restaurantVouchers,
    selectedPaymentOption,
    translate: getTranslate(state.locale),
  };
};

const mapDispatchToProps = (
  dispatch: ThunkDispatch<Store.State, {}, Action>,
) => ({
  actions: {
    loadUserSavedRestaurantVoucherStatus: (
      paymentAccountId: number,
      prId: number,
    ): void => {
      dispatch(
        loadUserSavedRestaurantVoucherStatus({
          paymentAccountId,
          storeId: prId,
        }),
      );
    },
    loadUserSavedRestaurantVouchers: (prId: number): void => {
      dispatch(loadUserSavedRestaurantVouchers({ storeId: prId }));
    },
    loadCategorizeMenuitems: (menuItemIds: number[]): void => {
      dispatch(loadCategorizeMenuitems({ MenuItemIds: menuItemIds }));
    },
    selectPaymentOption: (paymentId: string): void => {
      dispatch(basketActions.selectPayment({ paymentId }));
    },
  },
});

export const RestaurantVoucherSection = connect(
  mapStateToProps,
  mapDispatchToProps,
)(RestaurantVoucherSectionPartial);
